import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faTwitter, faInstagram, faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { useNavigate } from "react-router-dom";
import "./footer.css";
import { useLanguage } from "../../i18n/LanguageContext";

function Footer() {
    const navigate = useNavigate();
    const { t, lang } = useLanguage();

    return (
        <footer className="footer bg-dark text-light pt-5 pb-3 mt-5">
            <div className="container">
                <div className="row g-4">
                    {/* Brand Section */}
                    <div className="col-lg-3 col-md-6">
                        <h5 className="fw-bold mb-1" style={{ color: 'var(--gb-accent)' }}>GharBhada</h5>
                        <p className="small text-light mb-3">{t('footer.tagline')}</p>
                        <p className="text-muted small">
                            {t('footer.desc')}
                        </p>
                        <div className="d-flex gap-3 mt-3">
                            <button type="button" className="footer-icon-button text-light" aria-label="Facebook" style={{ fontSize: '1.5rem' }}>
                                <FontAwesomeIcon icon={faFacebook} />
                            </button>
                            <button type="button" className="footer-icon-button text-light" aria-label="Twitter" style={{ fontSize: '1.5rem' }}>
                                <FontAwesomeIcon icon={faTwitter} />
                            </button>
                            <button type="button" className="footer-icon-button text-light" aria-label="Instagram" style={{ fontSize: '1.5rem' }}>
                                <FontAwesomeIcon icon={faInstagram} />
                            </button>
                            <button type="button" className="footer-icon-button text-light" aria-label="LinkedIn" style={{ fontSize: '1.5rem' }}>
                                <FontAwesomeIcon icon={faLinkedin} />
                            </button>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div className="col-lg-3 col-md-6">
                        <h6 className="fw-bold mb-3 text-light">{t('footer.quickLinks')}</h6>
                        <ul className="list-unstyled">
                            <li className="mb-2">
                                <button
                                    type="button"
                                    className="text-light text-decoration-none hover-link"
                                    onClick={() => navigate('/find-property')}
                                >
                                    {t('footer.browse')}
                                </button>
                            </li>
                            <li className="mb-2">
                                <button
                                    type="button"
                                    className="text-light text-decoration-none hover-link"
                                    onClick={() => navigate('/list-property')}
                                >
                                    {t('footer.list')}
                                </button>
                            </li>
                            <li className="mb-2">
                                <button
                                    type="button"
                                    className="text-light text-decoration-none hover-link"
                                    onClick={() => navigate('/list-property')}
                                >
                                    {t('footer.becomeHost')}
                                </button>
                            </li>
                            <li className="mb-2">
                                <button
                                    type="button"
                                    className="text-light text-decoration-none hover-link"
                                    onClick={() => navigate('/help')}
                                >
                                    {t('footer.helpCenter')}
                                </button>
                            </li>
                            <li className="mb-2">
                                <button
                                    type="button"
                                    className="text-light text-decoration-none hover-link"
                                    onClick={() => navigate('/about')}
                                >
                                    {lang === "ne" ? "हाम्रो बारेमा" : "About Us"}
                                </button>
                            </li>
                        </ul>
                    </div>

                    {/* Support */}
                    <div className="col-lg-3 col-md-6">
                        <h6 className="fw-bold mb-3 text-light">{t('footer.support')}</h6>
                        <ul className="list-unstyled">
                            <li className="mb-2">
                                <button type="button" className="text-light text-decoration-none hover-link" onClick={() => navigate('/contact')}>
                                    {t('footer.contact')}
                                </button>
                            </li>
                            <li className="mb-2">
                                <button type="button" className="text-light text-decoration-none hover-link" onClick={() => navigate('/safety')}>
                                    {t('footer.safety')}
                                </button>
                            </li>
                            <li className="mb-2">
                                <button type="button" className="text-light text-decoration-none hover-link" onClick={() => navigate('/community-guidelines')}>
                                    {t('footer.community')}
                                </button>
                            </li>
                            <li className="mb-2">
                                <button type="button" className="text-light text-decoration-none hover-link" onClick={() => navigate('/terms-of-service')}>
                                    {t('footer.terms')}
                                </button>
                            </li>
                        </ul>
                    </div>

                    {/* Contact */}
                    <div className="col-lg-3 col-md-6">
                        <h6 className="fw-bold mb-3 text-light">{t('footer.contactSection')}</h6>
                        <ul className="list-unstyled text-light small">
                            <li className="mb-2">
                                <a href="mailto:support@gharbhada.org" className="text-light text-decoration-none hover-link">
                                    support@gharbhada.org
                                </a>
                            </li>
                            <li className="mb-2">{t('footer.location')}</li>
                            <li className="mb-2">{t('footer.hours')}</li>
                            <li className="mb-2">{t('footer.welcome')}</li>
                        </ul>
                    </div>
                </div>

                <hr className="my-4 border-secondary" />

                {/* Bottom Bar */}
                <div className="row">
                    <div className="col-md-6 text-center text-md-start">
                        <p className="text-muted small mb-0">
                            {t('footer.copyright')}
                        </p>
                    </div>
                    <div className="col-md-6 text-center text-md-end">
                        <button type="button" className="text-light text-decoration-none hover-link small me-3" onClick={() => navigate('/privacy-policy')}>
                            {t('footer.privacy')}
                        </button>
                        <button type="button" className="text-light text-decoration-none hover-link small me-3" onClick={() => navigate('/terms-of-service')}>
                            {t('footer.terms')}
                        </button>
                        <button type="button" className="text-light text-decoration-none hover-link small" onClick={() => navigate('/cookie-policy')}>
                            {t('footer.cookie')}
                        </button>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
